import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OfferTelcelWithoutLine from '../organisms/OfferTelcelWithoutLine';
import OfferTelcelWithLine from '../organisms/OfferTelcelWithLine';
import { selectPaymentServiceConf } from '../../store/selectors/paymentsSelectors';
import { getTelcelLineInformation, getPaymentMethods, getUserInfo, getUserInfoLite, setIsAnonimous, setStartEventLoginIsOver, setCreditCardInfo } from '../../store/actions';
import { 
    OFFER_TELCEL_POSPAGO, 
    OFFER_TELCEL_RECARGA
} from '../../constants';
import ModalCardLoader from '../molecules/ModalCardLoader'

class FullOfferTelcelContainer extends Component {
    constructor(props) {
        super(props);

        const {
            userInfo, 
            paymentsConfig,
            paymentMethods
        } = this.props

        const isAnonimous = this.props.isAnonimous || (paymentMethods && paymentMethods.cardList.length === 0 && !paymentMethods.hasN2) 
            ? true : false;        

        this.state = {
            isUserTelcel: userInfo.isTelcel === "true" || userInfo.isTelcel === true ? true:false,
            configPospago: paymentsConfig.services[OFFER_TELCEL_POSPAGO],
            configPrepago: paymentsConfig.services[OFFER_TELCEL_RECARGA],
            callServices: false,
            callCounterPaymentMethods : 1,
            isAnonimous: isAnonimous
        }
    }

    componentDidMount() {  
        const { paymentsConfig, getTelcelLineInformation, isAnonimous } = this.props;
        const { isUserTelcel } = this.state;
        
        this.handleGetPaymentMethods();

        if (
            (!isAnonimous && isUserTelcel) ||
            (isAnonimous && paymentsConfig.msisdn)
        ) {            
            getTelcelLineInformation();    
            this.setState({ callServices: true })
        }     
        
        if (!isAnonimous && !isUserTelcel) {
            this.setState({ callServices: true })
        }
    }

    componentDidUpdate(prevProps) {
        const {
            userInfo,
            paymentMethods,
            getUserInfo,
            getUserInfoLite,
            setIsAnonimous,
            lineTelcelInformation,
            setStartEventLoginIsOver,
            setCreditCardInfo
        } = this.props;

        if (this.props.lineTelcelInformation !== prevProps.lineTelcelInformation) {
            const { lineTelcelInformation } = this.props;            
            if (lineTelcelInformation.isTelcel) {
                this.setState({isUserTelcel: true});
            }
            this.setState({callServices: true})
        }

        //

        if (this.props.startEventLoginIsOver !== prevProps.startEventLoginIsOver) {
            if (this.props.startEventLoginIsOver) {
                this.setState({ callServices: false });
                setCreditCardInfo(undefined);
                getUserInfoLite();
            }
        }

        if (this.props.startEventOnboardingIsOver !== prevProps.startEventOnboardingIsOver) {
            if (this.props.startEventOnboardingIsOver) {
                setCreditCardInfo(undefined);
                getUserInfoLite();
            }
        }

        if (this.props.userInfoLite !== prevProps.userInfoLite) {
            if (this.props.startEventLoginIsOver) {
                getUserInfo();
            }
            if (this.props.startEventOnboardingIsOver) {
                getUserInfo();
            }
        }

        if (userInfo !== prevProps.userInfo) {
            if (this.props.startEventLoginIsOver) {
                this.handleGetPaymentMethods();
                if ((userInfo.isTelcel === "true" || userInfo.isTelcel === true) && !lineTelcelInformation) {
                    this.props.getTelcelLineInformation();
                } else {
                    this.setState({ callServices: true });
                }
            }
            if (this.props.startEventOnboardingIsOver) {
                this.handleGetPaymentMethods();
            }
        }

        if (paymentMethods !== prevProps.paymentMethods) {
            if (this.props.startEventLoginIsOver) {
                const { cardList, hasN2 } = paymentMethods;
                if (cardList && cardList.length === 0 && !hasN2) {
                    ClaroSDKService.openOnBoarding(false);
                }
                setStartEventLoginIsOver(false);
                setIsAnonimous(false);
            }
        }
    }

    handleGetPaymentMethods() {
        const {configPospago} = this.state;
        const {serviceId} = configPospago.serviceData.info;
        const { 
            getPaymentMethods, 
            paymentsConfig: {isClaroPartner}
        } = this.props;

        getPaymentMethods(serviceId, isClaroPartner);
    }

    render() {
        const {
            lineTelcelInformation, 
            isLoadingGetLineTelcelInformation, 
            history, 
            paymentMethods,  
            paymentsConfig:{
                offerWithoutLineTelcel, 
                isClaroPartner, 
                offerWithoutLineTelcelAnonimo
            },
            isLoadingGetPaymentMethods, 
            errorPaymentMethods, 
            getPaymentMethods,
            isLoadingAppSync
        } = this.props

        const {isUserTelcel, callServices, callCounterPaymentMethods, configPospago, isAnonimous} = this.state
        const {serviceId} = configPospago.serviceData.info
        if(!isLoadingGetPaymentMethods && errorPaymentMethods && paymentMethods == undefined){ 
            if(callCounterPaymentMethods <= 2) {
                this.setState({callCounterPaymentMethods:callCounterPaymentMethods +1})
                getPaymentMethods(serviceId, isClaroPartner);
            }
        }

        return (
            <>
            {
                !isLoadingGetLineTelcelInformation &&
                isUserTelcel &&
                lineTelcelInformation &&
                (
                    (!isAnonimous && paymentMethods) ||
                    (isAnonimous)
                ) ? <OfferTelcelWithLine history={history} isContainerTelcel={this.props.isContainerTelcel} /> : <></>
            }
                        
            {   
                (!isLoadingGetLineTelcelInformation && !isLoadingGetPaymentMethods && isAnonimous) ||
                (callServices && !isUserTelcel) ||
                (
                    isUserTelcel && callServices &&
                    (
                        
                        (!isLoadingGetLineTelcelInformation && !lineTelcelInformation) || 
                        (!isLoadingGetPaymentMethods && !paymentMethods)
                    )
                )
                 ?
                <OfferTelcelWithoutLine 
                    showBanner={true}
                    offerTelcel={!isAnonimous ? offerWithoutLineTelcel : offerWithoutLineTelcelAnonimo}
                    history={history}
                    planType={"Otro carrier"}
                    subtitleAlign={"center"}
                    subtitleMargin={"5% 0% 2% 0%"} 
                    logoIsVisible={"block"}
                    subtitle={"Elige una opción"}
                    isContainerTelcel={this.props.isContainerTelcel}
                    showButtonPay={true}
                /> :<></>
            }
            <ModalCardLoader 
                isOpen={
                    isLoadingGetLineTelcelInformation || 
                    isLoadingGetPaymentMethods ||
                    isLoadingAppSync 
                } 
            />
            </>
        )
    }
}

function mapStateToProps(state) {
    const { 
        isLoadingGetLineTelcelInformation,
        lineTelcelInformation,
        userInfo,
        userInfoLite,
        paymentMethods, 
        isLoadingGetPaymentMethods,
        errorPaymentMethods,
        isAnonimous,
        startEventLoginIsOver,
        startEventOnboardingIsOver,
        isLoadingAppSync
    } = state.payments;

    return {
        userInfo,
        userInfoLite,
        paymentsConfig: selectPaymentServiceConf(state.payments),
        isLoadingGetLineTelcelInformation,
        lineTelcelInformation,
        isLoadingGetPaymentMethods,
        errorPaymentMethods,
        paymentMethods,
        isAnonimous,
        startEventLoginIsOver,
        startEventOnboardingIsOver,
        isLoadingAppSync
    };
}

function mapDispatchToProps(dispatch) {
    
  return bindActionCreators(
    {
        getTelcelLineInformation,
        getPaymentMethods,
        getUserInfo,
        getUserInfoLite,
        setIsAnonimous,
        setStartEventLoginIsOver,
        setCreditCardInfo,
    },
    dispatch,
  );
}

FullOfferTelcelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FullOfferTelcelContainer);

export default FullOfferTelcelContainer